window.$ = window.jQuery = require('jquery');
var Clipboard = require('clipboard');
var Utils = require('./utils');

var clpbrd = new Clipboard('#copy-share');
var copied = $('#link-copied');
var shareCopy = $('#share-copy');
var enterContest = $('#enter-contest');
var getQueryStringValue = function (key) {
  return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}
var showShare = getQueryStringValue('showShare');
if(showShare === 'false') {
  sharCopy.hide();
  enterContest.show();
}
copied.hide();
clpbrd.on('success', function(e) {
  copied.show();
	setTimeout(function() {
    copied.hide();
	}, 3500);
});

$(document).ready(function() {
  // Check cookieBanner
  var cookiePopUp = $('.cookie-popup-wrap');
  var cookieName = '_petparade_cookie_check';
  var cookieCheck = Utils.getCookie(cookieName);
  if(!cookieCheck) cookiePopUp.show();
  $('#set-check-cookie').on('click', function() {
    var cookieExpires = Utils.getCookieExpires();
    Utils.setCookie(cookieName, true, cookieExpires);
    cookiePopUp.hide();
  });
});
